<template>

  <div style="height: 100%">
    <router-view/>
  </div>

</template>

<script>

</script>

<style>
*{
  box-sizing: border-box;
}
</style>